/**
 * Copyright © 2019 7thCode.(http://seventh-code.com/)
 * This software is released under the MIT License.
 * opensource.org/licenses/mit-license.php
 */

"use strict";

import { Component, Inject, NgZone, Input, EventEmitter } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { BaseDialogComponent } from "../../../platform/base/components/base-dialog.component";
import { TranslateService } from "@ngx-translate/core";
import _ from "lodash";
import { NgxLinkifyjsService, Link, LinkType } from "ngx-linkifyjs";
import { SessionService } from "../../../platform/base/services/session.service";

import { environment } from "../../../../environments/environment";

/**
 *
 *
 * @since 0.01
 */
@Component({
	selector: "description-dialog",
	styleUrls: ["./description-dialog.component.css"],
	templateUrl: "./description-dialog.component.html",
})
export class DescriptionDialogComponent extends BaseDialogComponent {
	public endPoint: string = "";
	public memo = "";
	public memoHTML = "";
	public advice = "";
	public adviceHTML = "";
	public editMode = true;
	public isSaving = false;
	public isShowInputChatGPT = false;
	public device = "desktop";
	public renderTime = 0;
	public isSetEndFocusMemo = false;

	public updateMemo = new EventEmitter<any>();

	public _ = _;

	@Input() public calculateDiagnoseResult: any;
	@Input() public size: number[];
	@Input() public style: any;
	@Input() public view_mode: any;

	/**
	 * @constructor
	 * @param data
	 * @param matDialogRef
	 * @param zone
	 */
	constructor(
		@Inject(MAT_DIALOG_DATA)
		public data: any,
		public matDialogRef: MatDialogRef<DescriptionDialogComponent>,
		private zone: NgZone,
		public translate: TranslateService,
		public linkifyService: NgxLinkifyjsService,
		public session: SessionService
	) {
		super();
		this.endPoint = environment.endPoint;
		this.calculateDiagnoseResult = this.data.calculateDiagnoseResult;
		this.size = this.data.size;
		this.view_mode = this.data.view_mode;
		this.device = this.data.device;

		console.log("device", this.device);

		this.memo = _.get(this.calculateDiagnoseResult, "input.memo", "") || "";
		this.memoHTML = this.linkifyService.linkify(this.memo); // .split('\n').join('<br />')

		this.advice = (
			_.get(
				this.calculateDiagnoseResult,
				"input.request_advice.chatgpt.contentDisplay",
				""
			) || ""
		)
			.split("。\n")
			.join("。")
			.split("。")
			.join("。\n");
		this.adviceHTML = this.linkifyService.linkify(this.advice);

		this.updateMemo.subscribe((msg) => {
			if (msg.type == "save_memo_success") {
				this.matDialogRef.close();
				this.isSaving = false;
			}
		});
		this.isShowInputChatGPT =
			_.get(this.session, "cache.configModel.show_input_chat_gpt") ||
			false;
	}

	public changeEditMode() {
		this.editMode = !this.editMode;
		if (!this.editMode) {
			this.memo = (
				document.getElementById(
					"edit-advice-content"
				) as HTMLInputElement
			).value
				.replace(/<div>/g, "\n")
				.replace(/<\/div>/g, "")
				.replace(/<br>/g, "")
				.substr(0, 1000);

			this.memoHTML = this.linkifyService.linkify(this.memo);
		}
	}

	public handeChangeMemo(event) {
		this.memo = event.target.value;
		this.memoHTML = this.linkifyService.linkify(this.memo);
	}

	public saveShotMemo() {
		// this.memo = (
		// 	document.getElementById("edit-advice-content") as HTMLInputElement
		// ).value
		// 	.replace(/<div>/g, "\n")
		// 	.replace(/<\/div>/g, "")
		// 	.replace(/<br>/g, "")
		// 	.substr(0, 1000);

		this.memoHTML = this.linkifyService.linkify(this.memo);

		this.updateMemo.emit({
			type: "save_memo",
			data: {
				calculateDiagnoseResult: this.calculateDiagnoseResult,
				memo: this.memo,
			},
		});
	}

	public isViewPC() {
		return window.innerWidth > window.innerHeight;
	}

	/**
	 *
	 */
	public cancel(): void {
		this.matDialogRef.close(null);
	}

	/**
	 *
	 */
	public onAccept(): void {
		this.matDialogRef.close(this.data);
	}

	public onResize(event) {
		this.renderTime += 1;
		console.log("onResize", event);
	}

	public getHeightAdvice() {
		let safeAreaInsetBottom =
			parseFloat(
				getComputedStyle(document.documentElement).getPropertyValue(
					"--safe-area-inset-bottom"
				)
			) || 0;

		let height = window.innerHeight - safeAreaInsetBottom - 118 + "px";
		// console.log("getHeightAdvice", height);
		return height;
	}
	public getHeightMemo() {
		let safeAreaInsetBottom =
			parseFloat(
				getComputedStyle(document.documentElement).getPropertyValue(
					"--safe-area-inset-bottom"
				)
			) || 0;

		let height =
			Math.min(window.innerHeight - safeAreaInsetBottom, 300 - 10) -
			210 +
			"px";

		console.log("getHeightMemo", height);
		return height;
	}

	public isMobile() {
		var isMobile =
			/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
				navigator.userAgent
			);

		return isMobile;
	}

	public getLogInfo() {
		let safeAreaInsetBottom =
			parseFloat(
				getComputedStyle(document.documentElement).getPropertyValue(
					"--safe-area-inset-bottom"
				)
			) || 0;
		var isMobile =
			/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
				navigator.userAgent
			);

		let isIPad =
			/iPad|iPhone|iPod/.test(navigator.platform) ||
			(navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

		return JSON.stringify({
			isMobile,
			isIPad,
			safeAreaInsetBottom,
			innerHeight,
		});
	}

	public onTextAreaFocus = ($event) => {
		if (!this.isSetEndFocusMemo) {
			this.isSetEndFocusMemo = true;
			let textarea = $event.currentTarget;
			textarea.focus();

			textarea.setSelectionRange(
				textarea.value.length,
				textarea.value.length
			);
		}
	};
}
